PopOver = require 'views/lib/pop-over'
template = require 'views/templates/popover_set_list_limit'
Util = require 'lib/util'
View = require 'view'

WIP_LOWER_LIMIT = 0
WIP_UPPER_LIMIT = 5000

isValidListLimit = (value) ->
  return value == null || (!isNaN(value) && value >= WIP_LOWER_LIMIT && value <= WIP_UPPER_LIMIT)

module.exports = class ListMoveView extends View
  viewTitleKey: 'set list limit'

  tagName: 'form'

  events:
    'click .js-submit': 'submit'
    'submit': 'submit'
    'keyup .js-list-limit-input': 'limitChanged'

  getValue: ->
    valueString = @$('.js-list-limit-input').val()

    if !valueString.length
      return null

    return parseInt(valueString)

  limitChanged: (e) ->
    value = @getValue()
    isValid = isValidListLimit(value)

    @$('.js-list-limit-input').toggleClass('is-invalid', !isValid)
    @$('.js-submit').attr('disabled', !isValid)

  submit: (e) ->
    Util.stop(e)

    value = @getValue()

    if isValidListLimit(value)
      @model.setSoftLimit(value)
      PopOver.hide()

  render: ->
    view = @
    model = view.model

    data =
      limit: model.get('softLimit')

    @$el.html(
      template(data)
    )

    @



// WEBPACK FOOTER //
// ./app/scripts/views/list/list-set-limit-view.coffee